import React from 'react';
import {
  Card,
  Stack,
  Typography,
} from '@mui/material';

const SectionCard = ({ title, description, actions, children, sx, contentProps }) => {
  const { sx: contentSx, ...restContentProps } = contentProps || {};

  return (
    <Card
      sx={{
        p: 3.5,
        borderRadius: '12px !important',
        display: 'flex',
        flexDirection: 'column',
        background: '#FFFFFF',
        border: '1px solid rgba(122, 59, 193, 0.06)',
        boxShadow: '0 6px 18px rgba(15, 23, 42, 0.06)',
        ...(sx || {}),
      }}
    >
      <Stack spacing={2} sx={{ height: '100%', ...(contentSx || {}) }} {...restContentProps}>
        {(title || actions) && (
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
            <Stack spacing={0.5}>
              {title && (
                <Typography variant="h6" fontWeight={600}>
                  {title}
                </Typography>
              )}
              {description && (
                <Typography variant="body2" color="text.secondary">
                  {description}
                </Typography>
              )}
            </Stack>
            {actions}
          </Stack>
        )}
        {children}
      </Stack>
    </Card>
  );
};

export default SectionCard;
